<div class="lock-report-container">
    <div class="lock-report">
        <span class="ham-icon">
            <i class="shield-check-icon"></i>
        </span>
        <div class="wrapper">
            <div class="lock-report-title">{{ 'aumico_annual_report_sealed_tag' | i18next }}</div>
            <span class="lock-report-description">
                {{ 'aumico_annual_report_locked' | i18next }}
            </span>
            <span class="unlock-report" stopPropagation (click)="onUnlockReport()">
                {{ 'aumico_annual_report_Unlock' | i18next }}
            </span>
        </div>
    </div>
    <div class="lock-report-by">
        <ham-avatar type="circle" size="regular" [fullName]="lockedBy"></ham-avatar>
        <div class="wrapper">
            <div class="lock-by">
                {{ 'aumico_annual_report_sealed_by' | i18next }}
                {{ lockedBy }}
            </div>
            <span class="lock-at">
                {{ lockedAt | date : 'MMM d, y' }}
            </span>
        </div>
    </div>
</div>
